export enum ENTITY_TYPES {
    SITE = 'site',
    EVENTS = 'events',
}
